import { render, staticRenderFns } from "./tab-esign.vue?vue&type=template&id=2fdac6d9"
import script from "./tab-esign.vue?vue&type=script&lang=js"
export * from "./tab-esign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports